/* ============================================================================
   ROWMAN — journal
   Phase 1 §9.5 option A.
     · All fabricated seed counts removed. Likes and saves start at zero.
     · Likes and saves are per-device (localStorage) and are labelled as such
       in the UI. They are never presented as cross-visitor statistics.
     · Comments use Shopify's native, server-stored, moderated comment system.
     · The share interface is preserved exactly.
   ============================================================================ */
(function () {
  'use strict';

  var R = window.ROWMAN;
  if (!R) return;

  var strings = R.strings || {};
  var LS_LIKES = 'rowman.likes.v2';
  var LS_SAVES = 'rowman.saves.v2';

  function likes() { return R.local.get(LS_LIKES, {}); }
  function saves() { return R.local.get(LS_SAVES, {}); }

  /* ═══════════════════ MODULE: engagement bar ═══════════════════ */

  R.register({
    name: 'JournalEngage',
    scope: '[data-engage]',
    mount: function (bar) {
      var id = bar.getAttribute('data-article-id');
      if (!id) return;

      var likeBtn = bar.querySelector('[data-engage-like]');
      var saveBtn = bar.querySelector('[data-engage-save]');
      var commentBtn = bar.querySelector('[data-engage-comment]');

      function paint() {
        var L = likes(), S = saves();
        if (likeBtn) {
          var liked = !!L[id];
          likeBtn.classList.toggle('is-active', liked);
          likeBtn.setAttribute('aria-pressed', liked ? 'true' : 'false');
          var lc = likeBtn.querySelector('[data-engage-count]');
          if (lc) lc.textContent = liked ? '1' : '0';
        }
        if (saveBtn) {
          var saved = !!S[id];
          saveBtn.classList.toggle('is-active', saved);
          saveBtn.setAttribute('aria-pressed', saved ? 'true' : 'false');
        }
      }

      function onClick(e) {
        var el = e.target.closest('[data-engage-like], [data-engage-save]');
        if (!el) return;
        e.preventDefault();

        if (el === likeBtn) {
          var L = likes();
          L[id] ? delete L[id] : (L[id] = Date.now());
          R.local.set(LS_LIKES, L);
          R.announce(L[id] ? (strings.liked || 'Saved to your likes on this device')
                           : (strings.unliked || 'Removed from your likes'));
        } else if (el === saveBtn) {
          var S = saves();
          S[id] ? delete S[id] : (S[id] = Date.now());
          R.local.set(LS_SAVES, S);
          R.toast(S[id] ? (strings.savedLocal || 'Saved on this device')
                        : (strings.unsaved || 'Removed'));
        }
        paint();
      }

      function onComment(e) {
  var target = document.getElementById('comment-form') ||
               document.getElementById('comments');

  if (!target) return;

  e.preventDefault();

  target.scrollIntoView({
    behavior: R.motionAllowed() ? 'smooth' : 'auto',
    block: 'start'
  });

  var field = target.querySelector('textarea, input[type="text"]');

  if (field) {
    setTimeout(function () {
      field.focus();
    }, 400);
  }
}

      bar.addEventListener('click', onClick);
      if (commentBtn) commentBtn.addEventListener('click', onComment);
      paint();

      return function () {
        bar.removeEventListener('click', onClick);
        if (commentBtn) commentBtn.removeEventListener('click', onComment);
      };
    }
  });

  /* ═══════════════════ MODULE: share menu ═══════════════════ */

  R.register({
    name: 'JournalShare',
    scope: '[data-share]',
    mount: function (root) {
      var trigger = root.querySelector('[data-share-trigger]');
      var menu = root.querySelector('[data-share-menu]');
      if (!trigger || !menu) return;

      var url = root.getAttribute('data-share-url') || window.location.href;
      var title = root.getAttribute('data-share-title') || document.title;

      function close() {
  menu.classList.remove('is-open');
  menu.setAttribute('aria-hidden', 'true');
  trigger.setAttribute('aria-expanded', 'false');
}

function positionMenu() {
  menu.style.position = 'absolute';
  menu.style.left = '0';
  menu.style.top = 'calc(100% + 8px)';
}
function onTrigger(e) {
  e.preventDefault();
  e.stopPropagation();

  if (
    navigator.share &&
    window.matchMedia('(pointer: coarse)').matches
  ) {
    navigator.share({
      title: title,
      url: url
    }).catch(function () {});

    return;
  }

  var open = menu.classList.toggle('is-open');

  menu.setAttribute('aria-hidden', open ? 'false' : 'true');
  trigger.setAttribute('aria-expanded', open ? 'true' : 'false');

  if (open) {
    positionMenu();

    var firstItem = menu.querySelector(R.FOCUSABLE);
    if (firstItem) firstItem.focus();
  }
}

      function onMenu(e) {
        var copy = e.target.closest('[data-share-copy]');
        if (copy) {
          e.preventDefault();
          if (navigator.clipboard) {
            navigator.clipboard.writeText(url).then(function () {
              R.toast(strings.linkCopied || 'Link copied');
              close();
            }).catch(function () {
              R.toast(strings.copyFailed || 'Copy failed');
            });
          }
        }
      }

      function onOutside(e) { if (!root.contains(e.target)) close(); }
      function onKey(e) { if (e.key === 'Escape') close(); }

      trigger.addEventListener('click', onTrigger);
      menu.addEventListener('click', onMenu);
      document.addEventListener('click', onOutside);
      document.addEventListener('keydown', onKey);

      return function () {
        trigger.removeEventListener('click', onTrigger);
        menu.removeEventListener('click', onMenu);
        document.removeEventListener('click', onOutside);
        document.removeEventListener('keydown', onKey);
      };
    }
  });

  /* ═══════════════════ MODULE: saved filter on the journal index ═══════════════════ */

  R.register({
    name: 'JournalFilter',
    scope: '[data-journal-filter]',
    mount: function (nav) {
      var journal = nav.closest('.journal-index');
if (!journal) return;

function apply(mode) {
  var S = saves();
  var shown = 0;
  var cards = journal.querySelectorAll('[data-article-card]');

  cards.forEach(function (card) {
    var id = card.getAttribute('data-article-card');
    var match = mode === 'all' || !!S[id];

    card.hidden = !match;

    if (match) {
      shown++;
    }
  });

  var empty = journal.querySelector('[data-journal-empty]');

  if (empty) {
    empty.hidden = mode !== 'saved' || shown > 0;
  }

  nav.querySelectorAll('[data-jr-view]').forEach(function (button) {
    var active = button.getAttribute('data-jr-view') === mode;

    button.classList.toggle('is-active', active);
    button.setAttribute('aria-current', active ? 'true' : 'false');
  });
}
      function onClick(e) {
        var link = e.target.closest('[data-jr-view]');
        if (!link) return;
        e.preventDefault();
        apply(link.getAttribute('data-jr-view'));
      }

      nav.addEventListener('click', onClick);
      apply('all');
      return function () { nav.removeEventListener('click', onClick); };
    }
  });

  /* ═══════════════════ MODULE: native comment form ═══════════════════
     Shopify posts the comment and returns with ?comment_posted=true. */

  R.register({
    name: 'CommentForm',
    scope: '[data-comment-form]',
    mount: function (form) {
      function onSubmit() {
        var btn = form.querySelector('[type="submit"]');
        if (btn) btn.classList.add('rw-btn-loading');
      }
      form.addEventListener('submit', onSubmit);

      if (/comment_posted=true/.test(window.location.search)) {
        var status = document.querySelector('[data-comment-status]');
        if (status) {
          status.hidden = false;
          status.scrollIntoView({ behavior: R.motionAllowed() ? 'smooth' : 'auto', block: 'center' });
        }
      }
      return function () { form.removeEventListener('submit', onSubmit); };
    }
  });

}());
